import type React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as st from './styles.module.scss';
import cn from 'classnames';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const DnDList: React.FC<Props> = ({ children, className }) => {
  return (
    <div className={cn(st.videos, className)}>
      <DndProvider backend={HTML5Backend}>{children}</DndProvider>
    </div>
  );
};
